module.exports = __webpack_public_path__ + "static/media/CBDS-Screenshot-2.10dd3717.png";